<template>
  <div>
    <v-switch
      v-model="receivedNotifications.status.status"
      @change="onToggleNotification"
      label="Hourly price notifications"
      class="mt-2"
    ></v-switch>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("notifications/fetchNotification", 1);
  },
  computed: {
    receivedNotifications() {
      return this.$store.getters["notifications/notifications"];
    },
  },
  methods: {
    async onToggleNotification() {
      // Form is valid, perform form submission or other actions
      await this.$store.dispatch("notifications/toggleNotification", {
        status: this.receivedNotifications.status.status,
      });
    },
  },
};
</script>
